"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.staleContentHeaderName = exports.sdkVersionHeader = exports.waitForLoadingNewContentHeader = exports.continuationTokenHeaderName = void 0;
exports.continuationTokenHeaderName = 'X-Continuation';
exports.waitForLoadingNewContentHeader = 'X-KC-Wait-For-Loading-New-Content';
exports.sdkVersionHeader = 'X-KC-SDKID';
exports.staleContentHeaderName = 'X-Stale-Content';
//# sourceMappingURL=headers.js.map